'use strict';

function mixin(a, b) {
  if (!b) { return a; }
  for (var k in b) {
    if (b.hasOwnProperty(k)) {
      a[k] = b[k];
    }
  }
  return a;
}

module.exports = mixin;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/mixin.js
 ** module id = 1077
 ** module chunks = 0
 **/